import React from "react";

const PeopleReached = (props) => {
  return (
    <div class="card-section horizontal padded expand">
      <h3>People reached</h3>
      <div class="source-container move-down">
        <a
          data-w-id="162517ba-d020-fd16-216e-bfc48fc645f8"
          href="#"
          class="link-block w-inline-block"
        >
          <div class="bar-container has-cover">
            <div class="medium-text nudge-right">Alpha corp</div>
            <div class="data tiny nudge-left">8,503</div>
            <div class="measure-bar tall cover">
              <div class="metric stat" style="height: 7.99219px;"></div>
            </div>
          </div>
        </a>
        <a
          data-w-id="162517ba-d020-fd16-216e-bfc48fc64600"
          href="#"
          class="link-block nudge-down w-inline-block"
        >
          <div class="bar-container has-cover">
            <div class="medium-text nudge-right">Beta inc</div>
            <div class="data tiny nudge-left">6,492</div>
            <div class="measure-bar tall cover">
              <div class="metric stat asjvbnr" style="height: 7.99219px;"></div>
            </div>
          </div>
        </a>
        <a
          data-w-id="162517ba-d020-fd16-216e-bfc48fc64608"
          href="#"
          class="link-block nudge-down w-inline-block"
        >
          <div class="bar-container has-cover">
            <div class="medium-text nudge-right">Charlie co</div>
            <div class="data tiny nudge-left">3,592</div>
            <div class="measure-bar tall cover">
              <div class="metric stat aovuber" style="height: 7.99219px;"></div>
            </div>
          </div>
        </a>
        <a
          data-w-id="162517ba-d020-fd16-216e-bfc48fc64610"
          href="#"
          class="link-block nudge-down w-inline-block"
        >
          <div class="bar-container has-cover">
            <div class="medium-text nudge-right">Delta llc</div>
            <div class="data tiny nudge-left">2,819</div>
            <div class="measure-bar tall cover">
              <div class="metric stat afjovba" style="height: 7.99219px;"></div>
            </div>
          </div>
        </a>
      </div>
    </div>
  );
};

export default PeopleReached;
